import { render, staticRenderFns } from "./CurrentProductStats.vue?vue&type=template&id=70c02cfc&scoped=true"
import script from "./CurrentProductStats.vue?vue&type=script&lang=js"
export * from "./CurrentProductStats.vue?vue&type=script&lang=js"
import style0 from "./CurrentProductStats.vue?vue&type=style&index=0&id=70c02cfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c02cfc",
  null
  
)

export default component.exports